import { Inject, Injectable } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'angular-webstorage-service';


@Injectable()
export class StoreService {

    constructor(@Inject(SESSION_STORAGE) private storage: StorageService) {

    }

    public setItem(key: string, value: any): void {
        this.storage.set(key, value);
    }

    public getItem(key: string): any {
      return this.storage.get(key);
    }

    public removeItem(key: string): void {
        return this.storage.remove(key);
    }
}



// WEBPACK FOOTER //
// ./src/app/providers/store.service.ts